import React from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faTwitter } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

export default function SocialNav() {
  return (
    <nav>
          <a
            className="App-link"
            target="_blank"
            rel="noopener noreferrer"
            href="https://facebook.com/MileSoft.Co"
          >
            <FontAwesomeIcon icon={faFacebook} className="text-danger" /> 
          </a>
          <a
            className="App-link"
            target="_blank"
            rel="noopener noreferrer"
            href="https://twitter.com/MileSoftCo"
          >
            <FontAwesomeIcon icon={faTwitter} className="text-danger" /> 
          </a>
          <a
            className="App-link"
            target="_blank"
            rel="noopener noreferrer"
            href="mailto:MileSoft.Co@gmail.com"
          >
            <FontAwesomeIcon icon={faEnvelope} className="text-danger" />
          </a>
        </nav>
  )
}
